import axios from "axios";
import { authHeader } from "@/services/authHeader";

const resource = "api/admin-users";

export default {
  GetAdmins: () => {
    return axios.get(`${resource}`, {
      headers: authHeader()
    });
  },
  CreateAdmin: data => {
    return axios.post(`${resource}`, data, {
      headers: authHeader()
    });
  },
  DeleteAdmin: id => {
    return axios.delete(`${resource}/${id}`, {
      headers: authHeader()
    });
  }
};
